import { createContext } from 'react'
import type { NotificationType } from 'src/services/apollo/generated/graphql'

export const NotificationListContext = createContext<{
  open: boolean
  unreadCounts: {
    type?: NotificationType | undefined
    count?: number | undefined
  }[]
  closePanel: () => void
}>({
  open: false,
  unreadCounts: [],
  closePanel: () => {},
})
